import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00a76b0f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=00a76b0f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a76b0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a76b0f')) {
      api.createRecord('00a76b0f', component.options)
    } else {
      api.reload('00a76b0f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=00a76b0f&scoped=true", function () {
      api.rerender('00a76b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notify/noteList/index.vue"
export default component.exports